export const chordLibrary = {
  // --- Major ---
  C: [3, 3, 2, 0, 1, 0],
  D: [-1, 0, 0, 2, 3, 2],
  E: [0, 2, 2, 1, 0, 0],
  F: [1, 3, 3, 2, 1, 1],
  G: [3, 2, 0, 0, 0, 3],
  A: [-1, 0, 2, 2, 2, 0],
  B: [-1, 2, 4, 4, 4, 2],
  // --- Minor ---
  Cm: [-1, 3, 5, 5, 4, 3],
  Dm: [-1, 0, 0, 2, 3, 1],
  Em: [0, 2, 2, 0, 0, 0],
  Fm: [1, 3, 3, 1, 1, 1],
  Gm: [3, 5, 5, 3, 3, 3],
  Am: [-1, 0, 2, 2, 1, 0],
  Bm: [-1, 2, 4, 4, 3, 2],
  // --- 7ths ---
  C7: [-1, 3, 2, 3, 1, 0],
  D7: [-1, 0, 0, 2, 1, 2],
  E7: [0, 2, 0, 1, 0, 0],
  F7: [1, 3, 1, 2, 1, 1],
  G7: [3, 2, 0, 0, 0, 1],
  A7: [-1, 0, 2, 0, 2, 0],
  B7: [-1, 2, 1, 2, 0, 2],
  // --- Misc ---
  Cmaj7: [-1, 3, 2, 0, 0, 0],
  Fmaj7: [-1, -1, 3, 2, 1, 0],
  Gmaj7: [3, 2, 0, 0, 0, 2],
  Amaj7: [-1, 0, 2, 1, 2, 0],
  Am7: [-1, 0, 2, 0, 1, 0],
  Dm7: [-1, 0, 0, 2, 1, 1],
  Em7: [0, 2, 2, 0, 3, 0],
  Bm7: [-1, 2, 0, 2, 0, 2],
  Bb: [-1, 1, 3, 3, 3, 1],
  Eb: [-1, 6, 8, 8, 8, 6],
  "F#": [2, 4, 4, 3, 2, 2],
  "F#m": [2, 4, 4, 2, 2, 2],
  "C#m": [-1, 4, 6, 6, 5, 4],
  Ab: [4, 6, 6, 5, 4, 4],
};

export const toneProfiles = {
  acoustic: {
    type: "custom",
    filterStart: 3000,
    filterEnd: 0.1,
    duration: 2.0,
    gain: 0.8,
  },
  distortion: {
    type: "sawtooth",
    filterStart: 6000,
    filterEnd: 100,
    duration: 1.5,
    gain: 0.15,
  },
};

export const baseFreqs = [82.41, 110.0, 146.83, 196.0, 246.94, 329.63];
